var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4411 13L13 19.4411V28.5589L19.4411 35H28.5589L35 28.5589V19.4411L28.5589 13M19.6122 17.8889L24 22.2767L28.3878 17.8889L30.1111 19.6122L25.7233 24L30.1111 28.3878L28.3878 30.1111L24 25.7233L19.6122 30.1111L17.8889 28.3878L22.2767 24L17.8889 19.6122",
    fill: "#FF5050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledSupplyReqIcon);
export default __webpack_public_path__ + "static/media/cancelled-supply-req-icon.5b33fc743183c00d0c090961a666f6bd.svg";
export { ForwardRef as ReactComponent };